/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { useAppSnackbar } from "../../../../Basis/Components/AppSnackbarContext";
import IAppSnackbar from "../../../../Basis/Components/AppSnackbarContext/IAppSnackbar";
import ViewModel from "../../../../Basis/ViewModels/ViewModel";
import AendereEigeneEMail, { AendereEigeneEMailInput } from "../../Commands/AendereEigeneEMail";
import AendereEigeneEMailDialogModelProps from "./AendereEigeneEMailDialogProps";
import AendereEigeneEMailDialogState, { createInitialState } from "./AendereEigeneEMailDialogState";

export default class AendereEigeneEMailDialogModel extends ViewModel<AendereEigeneEMailDialogState> {
    private readonly _snackbar: IAppSnackbar;
    private readonly _aendereEigeneEMail: AendereEigeneEMail;

    public constructor(private readonly _props: AendereEigeneEMailDialogModelProps) {
        super({
            initialState: createInitialState(),
        });
        this._snackbar = useAppSnackbar();
        this._aendereEigeneEMail = new AendereEigeneEMail([]);
    }

    public get kannAendern(): boolean {
        return this.state.neueEMail.length > 3 &&
            this.state.neueEMail.indexOf("@") > 0 &&
            this.state.neueEMail.indexOf(".") > 0;
    }

    public get isOpen(): boolean {
        return this._props.isOpen;
    }

    public readonly aendereEigeneEMail = () => {
        this.setState((nextState) => nextState.actionsDisabled = true);
        this.executeCommandAsync(async () => {
            try {
                await this._aendereEigeneEMail.execute(this.getExecuteInput());
            } catch {
                this.setState((nextState) => nextState.actionsDisabled = false);
                return;
            }

            this.reset();
            this._props.onEigeneEMailGeaendert();
        });
    };

    public readonly abbrechen = () => {
        this.reset();
        this._props.onAendereEigeneEMailAbgebrochen();
        this._snackbar.clear();
    };

    private getExecuteInput(): AendereEigeneEMailInput {
        return {
            neueEMail: this.state.neueEMail
        };
    }
}
